export const parseFormattedNumber = (str, decimal = null) => {
  if (!str) {
    return null;
  }

  let normalized = str;
  if (decimal) {
    normalized = normalized.replace(decimal, '.');
  }

  normalized = normalized.replace(/[^\d.]/g, '');
  const num = Number.parseFloat(normalized);
  return Number.isNaN(num) ? null : num;
};
